import React, { useState } from "react";
import { getCurrentUser } from "./api";
import Login from "./components/Login";
import Shell from "./components/Shell";
import ShellV2 from "./components/ShellV2";
import ShellV3 from "./components/ShellV3";
import ShellV4 from "./components/ShellV4";
import { ToastProvider } from "./components/Toast";
import { ThemeProvider } from "./components/Theme";
import { VersionProvider, useVersion } from "./components/Version";

function AppInner({ user, setUser }) {
  const { version } = useVersion();
  if (!user) return <Login onLogin={setUser} />;
  if (version === "v4") return <ShellV4 user={user} setUser={setUser} />;
  if (version === "v3") return <ShellV3 user={user} setUser={setUser} />;
  if (version === "v2") return <ShellV2 user={user} setUser={setUser} />;
  return <Shell user={user} setUser={setUser} />;
}

export default function App() {
  const [user, setUser] = useState(getCurrentUser());
  return (
    <VersionProvider>
      <ThemeProvider>
        <ToastProvider>
          <AppInner user={user} setUser={setUser} />
        </ToastProvider>
      </ThemeProvider>
    </VersionProvider>
  );
}
